<template>
  <a-table
    :columns="columns"
    :data-source="list"
    :scroll="{ x: 0, y }"
    :pagination="false"
    :loading="loading"
    :destroyOnClose="true"
    :forceRender="true"
    :rowClassName="rowClassName"
  >
    <template slot="rawName" slot-scope="text,record">
      {{overseasFlag == '1' ? (record.aliasName || text) : text}}
    </template>
    <template
      slot="numberFix3"
      slot-scope="text"
    >
      {{ text | numberFixed(3) }}
    </template>
    <template
      slot="numberFix2"
      slot-scope="text"
    >
      {{ text | numberFixed(2) }}
    </template>
    <template slot="difference" slot-scope="text, record">
      <span
        :class="{
          red: Number((record.percentage || 0) - (record.productPercentage || 0)) > 0,
          green: Number((record.percentage || 0) - (record.productPercentage || 0)) < 0
        }"
      >
        {{getNum(record)}}
        <!-- {{
          record.percentage && record.percentage !== 0 ?
          Number((record.percentage || 0) - (record.productPercentage || 0)) > 0 ? "+" : "" 
          : ''
        }}
        {{ record.percentage && record.percentage !== 0 ? Number(record.percentage - record.productPercentage).toFixed(3) : '' }} -->
      </span>
    </template>
    <template slot="cast" slot-scope="text, record">
      <span
        :class="{
          red:
            (record.percentage - record.productPercentage) /
              record.productPercentage >
            0,
          green:
            (record.percentage - record.productPercentage) /
              record.productPercentage <
            0
        }"
      >
        {{ text }}
      </span>
    </template>
  </a-table>
</template>

<script>
import { nhfMixins } from '../../untils'
// import { exportExcel } from "@/Utils/excel/Export2Excel";
export default {
  props:['hidden','tabKey','diff','y','loading'],
  mixins:[nhfMixins],
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      cacheData:[],
      columns:[
        {
          dataIndex:'rawName',
          title:'原料名称',
          width: 120,
          scopedSlots: {customRender: 'rawName'},
        },
        {
          dataIndex:'rawCode',
          title:'原料代码',
          width:100,
          align:'center'
        },
        {
          dataIndex:'price',
          title:'价格',
          width:100,
          align:'center',
          scopedSlots: {customRender: 'numberFix2'},
        },
        {
          dataIndex:'percentage',
          title:'配方(%)',
          scopedSlots: {customRender: 'numberFix3'},
          align:'center',
          width:100,
        },

        {
          dataIndex:'productPercentage',
          scopedSlots: {customRender: 'numberFix3'},
          title:'产品(%)',
          width:100,
          align:'center'
        },
        {
          dataIndex:'difference',
          title:'差异',
          scopedSlots: {customRender: 'difference'},
          sortOrder:'descend',
          width:100,
          sorter: (a, b) => {
            // const mins = (a.percentage || 0) - (a.productPercentage || 0)
            // const maxs = (b.percentage ||0) - (b.productPercentage || 0)
            // return mins - maxs
            return (a.difference || 0) - (b.difference || 0)
          },
          align:'center'
        },
        // {
        //   dataIndex:'differenceRate',
        //   title:'差异%',
        //   scopedSlots: {customRender: 'cast'},
        //   sorter: (a, b) => (( a.productPercentage === 0 || a.percentage === 0 ? 0 :(a.percentage - a.productPercentage) / a.productPercentage) - ( b.percentage === 0 || b.productPercentage ===0 ? 0 : (b.percentage - b.productPercentage) / b.productPercentage)),
        //   sortDirections: ['descend', 'ascend'],
        //   align:'center'
        // }
      ],
      list:[],
      batStatus:false,
      keyword:'',
      equationId:null,
      types:[],
      listLoading:false,
      calculateLoading:false,
      nutritionId:null,
      calculateResult:[],
      isContain:true,
      equation:{
        records:[]
      },
    }
  },
  watch:{
    hidden(visible){
      if(visible) this.getList()
    },
    // tabKey(val){
    //   if(val === 1) this.getList()
    // }
    diff(){
      this.filterList()
    }
  },
  mounted(){
    this.getList()
  },
  computed:{
    eidtorText(){
      return this.batStatus ? '取消编辑' : '批量编辑'
    }
  },
  methods:{
    toggleContain(isContain,list = false){
      this.$nextTick(()=>{
        let arrs = list || this.cacheData
        let arr = JSON.parse(JSON.stringify(arrs))
        this.list.records = isContain ? arr : arr.filter(i => i.isContain === "1")
      })
    },

    selectItem(val){
      if(val === undefined) {
        this.getList()
      }
    },

    typeChange(val){
      this.types = val
      this.getList({typeId:[...val].pop()})
    },

    async getList(arg= {}){
      this.$nextTick( async () => {
        const params = {
          formulaId:this.formulaId,
        }
        if(this.types.length) params.typeId=[...this.types].pop()
        this.listLoading = true
        const res = await this.getProductContrast({
          ...params,
          ...arg,
          size:1000
        }).finally(() => {
          this.$emit('checkLoadling')
        })
        if(res && res.data && res.msg !== '暂无承载数据'){
          res.data && res.data.map(el => {
            // el.difference = Math.abs((el.percentage || 0) - (el.productPercentage || 0)).toFixed(3)
            el.difference = Math.abs(this.getNum(el,'row'))
            return el
          })
          // this.list = res.data || []
          // 差异值按照绝对值从大到小排序
          // data && data.length && data.sort((a, b) => Math.abs(a.difference) - Math.abs(b.difference))
          this.cacheData = JSON.parse(JSON.stringify(res ? res.data || [] : []))
          this.filterList()
        }
        this.listLoading = false
      })
    },

    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },

    filterList(){
      if(this.diff){
        this.list = this.cacheData.filter(el => !!el.difference)
      }else{
        this.list = JSON.parse(JSON.stringify(this.cacheData))
      }
    },

    ok(){
      this.$emit('ok')
      this.resetRaw()
    },

    cancel(){
      this.$emit('cancel')
      this.resetRaw()
    },

    resetRaw(){
      this.keyword = ''
      this.types = []
      this.list.records = [...this.cacheData]
      this.cleanSelect()
    },
    getNum(record,type){
      let {percentage,productPercentage} = record || {}
      let num
      if(percentage || productPercentage || percentage === 0 || productPercentage === 0){
        num = Number((percentage || 0) - (productPercentage || 0)).toFixed(3)
      }else{
        if(type === 'row') num = 0
      }
      return num
    },
    rowClassName(record){
      let {isExtraProRaw,isRawDelete} = record || {}
      return isExtraProRaw == '1' || isRawDelete == '1' ? 'selectGary' : ''
    },
    
    downloadExcel() {
      let tHeader = this.columns.map((item) => {
        if(item.dataIndex != 'x') return item.title
      });
      let filterVal = this.columns.map((item) => item.dataIndex);
      let tTitle = `${this.detail.formulaName}-${new Date().getTime()}`;
      const list = JSON.parse(JSON.stringify(this.list));
      const data = this.formatJson(filterVal, list.sort((a,b) => (b.difference || 0) - (a.difference || 0)));
      // exportExcel(tHeader, data, tTitle);
      return {tHeader, data, tTitle}
    },
    formatJson(filterVal, jsonData) {
      let arr = ['percentage','productPercentage','difference']
      let fix2 = ['price']
      return jsonData.map((v) => filterVal.map((j) => {
        if(arr.includes(j)){
          if(j === 'difference'){
            return this.getNum(v)
          }else{
            return v[j] || v[j] === 0 ? Number(v[j]).toFixed(3) : ''
          }
        }
        else if(fix2.includes(j)){
          return v[j] || v[j] === 0 ? Number(v[j]).toFixed(2) : ''
        }
        else{
          return v[j]
        }
      }));
    },
  }
}
</script>
<style lang="scss" scoped>
.red {
  color: red;
}
.green {
  color: green;
}

</style>
<style lang="scss">
.grayBg{
  td{
    background: gray;
  }
}
</style>
